export default function Principalinfo(){
    let texto="Se muestran dos resultados principales por colección, si deseas ver más resultados da clic en [Más resultados de...] en la colección de tu interés.";
    if (window.location.href.indexOf("en.") > -1) {
        texto="Two main results are shown per collection, if you want to see more results click on [More results of ...] in the collection of your interest";
    }
    return(
    //   <div className="col-lg-2 col-md-3" id="informacionEncontrados" style={{textAlign:"justify", fontSize:"10px", float:"right", display:"none"}} aria-live="assertive" aria-atomic="true" aria-relevant="all">
        <div className="alert alert-secondary" id="informacionEncontrados" style={{display:"none", marginTop:"20px"}} aria-live="assertive" aria-atomic="true" aria-relevant="all">
        {texto}
        </div>
    )
}

